import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
// import { LayoutService } from '../../core/service/layout.service';
// import { Router, ActivatedRoute } from '@angular/router';
import { ReviewService } from '../service/review.service';
import { RegistrantType } from '../../accounts/model/RegistrantType';

export interface Reviewer {
  name: string;
  registrantType: number;
}

@Component({
    templateUrl: './changeReviewers.component.html',
    selector: 'app-change-reviewers',
    styleUrls: ['../list.scss', './review.scss'],
    standalone: false
})
export class ChangeReviewersComponent implements OnInit {

  constructor(private service: ReviewService) { }

  reviewers = [];
  techReviewers = [];
  techReviewersSorted = [];
  pharmReviewers = [];
  pharmReviewersSorted = [];
  layReviewers = [];
  changingReviewers;
  @Input() row;
  @Input() editing;
  @Output() changed = new EventEmitter();
  RegistrantType = RegistrantType;

  ngOnInit() {
    this.service.getReviewers().subscribe(data => {

      this.reviewers = data
        .map(reviewer => {
          reviewer.name = reviewer.name.slice(reviewer.name.indexOf(' ') + 1);  // remove salutation 
          reviewer.type = reviewer.registrantType ? (reviewer.registrantType === RegistrantType.Pharmacist ? 'Pharm' : 'Tech') : 'Lay';
          return reviewer;
        });

      this.techReviewers = this.reviewers
        .filter(reviewer => !reviewer.registrantType || reviewer.registrantType === RegistrantType.PharmacyTechnician);
      this.pharmReviewers = this.reviewers
        .filter(reviewer => !reviewer.registrantType || reviewer.registrantType === RegistrantType.Pharmacist);
      this.layReviewers = data
        .filter(reviewer => !reviewer.registrantType);

      // split, group & sort
      this.techReviewersSorted = this.customGroupAndSort(this.techReviewers, 'Tech', 'Lay');
      this.pharmReviewersSorted = this.customGroupAndSort(this.pharmReviewers, 'Pharm', 'Lay');
      this.layReviewers = this.layReviewers.sort(this.customSortByName);
    });
  }

  customSortByName(a: Reviewer, b: Reviewer): number {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0; // names are equal
  }

  customGroupAndSort(originalArray, type1, type2): [] {
    let group1 = originalArray
      .filter(reviewer => reviewer.type === type1)
      .sort(this.customSortByName);
    let group2 = originalArray
      .filter(reviewer => reviewer.type === type2)
      .sort(this.customSortByName);
    let sortedArray = group1.concat(...group2);
    return sortedArray;
  }

  validateReviewerSelection(row, event, rev) {
    this.editing[rev] = event;
    const lead = this.reviewers.find(reviewer => reviewer.userId === this.editing.lead);
    const secondary = this.reviewers.find(reviewer => reviewer.userId === this.editing.secondary);

    if (lead.registrantType && secondary.registrantType) {
      this.editing.isValid = false;
      this.editing.validationMessage = 'One of the reviewers must be a lay reviewer';
      return;
    }
    const rowRegistrantType = row.registrantType === RegistrantType.Pharmacist ? 'pharmacist' : 'technician';
    if (!lead.registrantType && !secondary.registrantType) {
      this.editing.isValid = false;
      this.editing.validationMessage = `One of the reviewers must be a ${rowRegistrantType}`;
      return;
    }

    if (row.registrantType === RegistrantType.Pharmacist) {
      if (!(lead.registrantType === RegistrantType.Pharmacist || secondary.registrantType === RegistrantType.Pharmacist)) {
        this.editing.isValid = false;
        this.editing.validationMessage = 'Pharmacist must be assigned a pharmacist reviewer';
        return;
      }
    }
    if (row.registrantType === RegistrantType.PharmacyTechnician) {
      if (!(lead.registrantType === RegistrantType.PharmacyTechnician || secondary.registrantType === RegistrantType.PharmacyTechnician)) {
        this.editing.isValid = false;
        this.editing.validationMessage = 'Pharmacy technician must be assigned a pharmacy technician reviewer';
        return;
      }
    }

    this.editing.isValid = true;
    this.editing.validationMessage = '';
  }

  get willChangeReviewers() {
    return this.editing.lead !== this.editing.row.leadReviewerUserId ||
      this.editing.secondary !== this.editing.row.secondaryReviewerUserId;
  }

  changeReviewers() {
    this.changingReviewers = true;
    this.service.changeReviewers(this.editing.row.id, this.editing.lead, this.editing.secondary).subscribe(() => {
      this.changingReviewers = false;
      this.editing.row.leadReviewerName = this.reviewers.find(reviewer => reviewer.
        userId === this.editing.lead).name;
      this.editing.row.leadReviewerUserId = this.editing.lead;
      this.editing.row.secondaryReviewerName = this.reviewers.find(reviewer => reviewer.
        userId === this.editing.secondary).name;
      this.editing.row.secondaryReviewerUserId = this.editing.secondary;

      this.changed.emit(this.editing.row);
      this.editing = { id: undefined, lead: undefined, secondary: undefined, row: undefined };
    });
  }
}